import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_resolveDynamicComponent($props.imageUrl ? $setup.BuilderEstimatorQuoterSummaryItemWithImage : $setup.BuilderEstimatorSummaryItemWithoutImage), {
    title: $props.title,
    value: $props.value,
    price: $props.price,
    imageUrl: $props.imageUrl
  }, null, 8, ["title", "value", "price", "imageUrl"]))
}